(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["xy-product-navigation"] && !Shopify.designMode) return;
  try {
    function setupProductNavigation() {
 document.querySelectorAll('.header__inline-menu').forEach(nav => {
  if (nav.dataset.xyNavigationReady) return;
  nav.dataset.xyNavigationReady = 'true';
  const desktopMouse = matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');
  const menus = [...nav.querySelectorAll(':scope > ul > li > header-menu > details')];
  const timers = new Map();
  const cancelClose = details => { clearTimeout(timers.get(details)); timers.delete(details); };
  const setOpen = (details, open) => {
   cancelClose(details);
   details.open = open;
   details.querySelector('summary')?.setAttribute('aria-expanded', String(open));
  };
  const closeOthers = current => menus.forEach(details => {
   if (details !== current) setOpen(details, false);
  });
  const openMenu = details => { closeOthers(details); setOpen(details, true); };
  menus.forEach(details => {
   const owner = details.parentElement;
   const summary = details.querySelector('summary');
   const panel = summary?.nextElementSibling;
   const enter = event => {
    if (event.pointerType === 'mouse' && desktopMouse.matches) openMenu(details);
   };
   const leave = event => {
    if (event.pointerType !== 'mouse' || !desktopMouse.matches) return;
    if (event.relatedTarget instanceof Node && owner.contains(event.relatedTarget)) return;
    cancelClose(details);
    timers.set(details, setTimeout(() => {
     timers.delete(details);
     if (!owner.matches(':hover') && !panel?.matches(':hover') && !owner.contains(document.activeElement)) {
      setOpen(details, false);
     }
    }, 260));
   };
   owner.addEventListener('pointerenter', enter);
   owner.addEventListener('pointerleave', leave);
   panel?.addEventListener('pointerenter', enter);
   panel?.addEventListener('pointerleave', leave);
   summary?.addEventListener('click', event => {
    if (desktopMouse.matches && event.detail > 0) {
     event.preventDefault();
     openMenu(details);
    }
   });
   details.addEventListener('toggle', () => {
    summary?.setAttribute('aria-expanded', String(details.open));
    if (details.open) closeOthers(details);
   });
   // Let keyboard focus move between menu links; don't close a hovered panel
   // when a previously focused trigger loses focus.
   details.addEventListener('focusout', event => {
    event.stopImmediatePropagation();
    cancelClose(details);
    timers.set(details, setTimeout(() => {
     timers.delete(details);
     if (!owner.contains(document.activeElement) && !(desktopMouse.matches && owner.matches(':hover'))) {
      setOpen(details, false);
     }
    }, 260));
   }, true);
  });
  document.addEventListener('click', event => {
   if (!nav.contains(event.target)) closeOthers(null);
  });
  nav.addEventListener('keydown', event => {
   if (event.key !== 'Escape') return;
   const active = menus.find(details => details.open);
   if (active) {
    setOpen(active, false);
    active.querySelector('summary')?.focus();
   }
  });
  desktopMouse.addEventListener('change', () => closeOthers(null));
 });
}
setupProductNavigation();
document.addEventListener('shopify:section:load', setupProductNavigation);
  } catch(e) { console.error(e); }
})();

})();
